import React, { Component } from "react";
import { View } from "react-native";
import Text from "../../components_v2/TextFont";
import { connect } from "react-redux";
import * as DeviceTypes from "./_deviceTypes";

import PropTypes from "prop-types";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import { IconButton } from "../../components_v2/Buttons";
import { getIsRTL } from "../../util";

class Thermometer extends Component {
  static propTypes = {
    deviceId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    areaId: PropTypes.oneOfType([PropTypes.number]),
    areaUId: PropTypes.oneOfType([PropTypes.string]),
    style: PropTypes.any,
  };

  constructor(props) {
    super(props);
  }
  render() {
    let model = {},
      currentTemperature = undefined,
      unit = "°C";
    let { deviceId, areaId, areaUId } = this.props;

    if (deviceId) {
      model =
        this.props.DeviceReducer.list.find(
          (d) =>
            (d.deviceId == deviceId || d.deviceUId == deviceId) &&
            d.deviceType == DeviceTypes.THERMO_METER
        ) || {};
      if (model) {
        currentTemperature = model.value;
        unit = model.unit;
      }
    } else if (areaId || areaUId) {
      //   var testAllThermoMeters = this.props.DeviceReducer.list.filter(
      //     (d) => d.deviceType == DeviceTypes.THERMO_METER
      //   ).map(d => d.deviceId);

      //   console.log('testAllThermoMeters', testAllThermoMeters)

      var area = this.props.AreaReducer.areas.find(
        (a) => a.areaId == areaId || a.areaUId === areaUId
      );
      if (area && area.devices) {
        var areaDevices = this.props.DeviceReducer.list
          .filter((d) => {
            if (
              d.deviceType == DeviceTypes.THERMO_METER &&
              area.devices.indexOf(d.deviceId || d.deviceUId) >= 0
            ) {
              //console.log('contains', d)
              return true;
            }
          })
          //   .filter(
          //     (d) =>
          //     area.devices.indexOf(d.deviceId) >= 0
          //   )
          .map((d) => {
            let {
              // deviceId, deviceType,
              value,
              unit,
            } = d;
            return { value, unit };
          });
        if (areaDevices.length > 0) {
          unit = areaDevices[0].unit;
          currentTemperature = 0;
          var validCount = areaDevices.length;
          for (var i in areaDevices) {
            var val = areaDevices[i].value;
            if (val == undefined || isNaN(val)) {
              validCount--;
              continue;
            }
            currentTemperature += val;
          }
          if (validCount > 0) {
            currentTemperature /= validCount;
            currentTemperature = Math.round(currentTemperature * 10) / 10;
          } else {
            currentTemperature = "-";
          }
        }
      }
    }

    let SelectedIcon = faCharCodes.faThermometerEmpty;
    let currentColor = "#ccc";

    if (currentTemperature == undefined || isNaN(currentTemperature)) {
      return null;
    } else if (currentTemperature < 20) {
      SelectedIcon = faCharCodes.faThermometerFrigid; //faCharCodes.faThermometerQuarter; //faThermometerQuarter;
      currentColor = "#00f6ff"; // turquoise / cold
    } else if (currentTemperature <= 25) {
      SelectedIcon = faCharCodes.faThermometerHalf; // faThermometerHalf;
      currentColor = "#a3d900"; // green / good
    } else if (currentTemperature <= 28) {
      SelectedIcon = faCharCodes.faThermometerThreeQuarters; // faThermometerThreeQuarters;
      currentColor = "#ffcc00"; // orange / warm
    } else {
      SelectedIcon = faCharCodes.faThermometerFull; //faThermometerFull;
      currentColor = "#ff5d00"; // dark orange / hot
    }
    return (
      <View
        style={{
          ...this.props.style,
          flexDirection: getIsRTL() ? "row-reverse" : "row",
          alignItems: "center",
          height: 30,
        }}
      >
        <IconButton
          icon={{
            code: SelectedIcon,
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 18,
              color: currentColor,
              paddingHorizontal: 5,
            },
          }}
        />
        <Text
          style={{
            //color: currentColor,
            fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
            fontSize: 18,
            marginHorizontal: 3,
          }}
        >
          {currentTemperature}
        </Text>
        <Text
          style={{
            //color: "#ccc",
            fontSize: 10,
            alignSelf: "baseline",
            paddingTop: 7,
            paddingStart: 3,
          }}
        >
          {unit}
        </Text>
      </View>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //localFucntion : (deviceId) => dispatch(Actions.ActionName(deviceId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Thermometer);
